import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=5c074946"
import script from "./AttachmentInput.vue?vue&type=script&lang=js"
export * from "./AttachmentInput.vue?vue&type=script&lang=js"
import style0 from "./AttachmentInput.vue?vue&type=style&index=0&id=5c074946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports